<template>
  <header class="scrollHeader header">
    <div
      class="w-full max-w-7xl mx-auto h-[60px] [@media(max-width:1280px)]:px-[50px] flex items-center flex-row justify-around [@media(max-width:880px)]:justify-between cursor-pointer"
    >
      <div class="flex flex-row items-center [@media(max-width:1024px)]:text-[18px]">
        <img class="w-[24px] h-[24px] mr-[6.25px]" src="@/assets/imgs/logo.png" alt="Women's Bible logo" />
        <span class="font-bold text-[18px] whitespace-nowrap">Women's Bible</span>
      </div>
      <div class="flex flex-1 justify-around items-center [@media(max-width:880px)]:hidden px-[30px] text-[16px] font-400 text-[#000000]">
        <div
          class="nav-link"
          @click="scrollTo(item.value)"
          v-for="item in tabs"
          :key="item.value"
          :class="{ active: props.currentPage === item.value }"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="flex items-center">
        <button
          class="font-medium text-[16px] text-[#47201A] border border-[#47201A] rounded-[15px] flex items-center justify-center w-[140px]"
          @click="handleDownloadClick"
        >
          Download App
        </button>

        <button
          class="block [@media(min-width:880px)]:hidden text-white ml-[16px]"
          @click="isMobileMenuOpen = !isMobileMenuOpen"
          aria-label="Toggle menu"
        >
          <svg class="w-6 h-6" fill="none" stroke="black" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      <transition name="slide-fade">
        <div v-if="isMobileMenuOpen" class="fixed top-0 right-0 w-2/3 h-[100vh] bg-black/95 text-white p-4 z-50 flex flex-col space-y-4 z-1000">
          <button class="self-end mb-4 text-[18px]" @click="isMobileMenuOpen = false" aria-label="Close menu">✕</button>
          <div class="text-[18px] gap-2 cursor-pointer flex flex-col">
            <div @click="scrollTo(item.value)" v-for="item in tabs" :key="item.value">
              {{ item.label }}
            </div>
          </div>
        </div>
      </transition>
    </div>
  </header>
</template>

<script setup lang="ts">
import { sendTA } from '@/assets/js/TA'
import { ref } from 'vue'
const props = defineProps({
  currentPage: {
    default: 'home',
  },
})
const emit = defineEmits(['update:page'])

const tabs = [
  { label: 'Home', value: 'home' },
  { label: 'Function', value: 'function' },
  { label: 'Values', value: 'values' },
  { label: 'Features', value: 'features' },
  { label: 'FAQ', value: 'faq' },
]

function scrollTo(value: string) {
  emit('update:page', value)
}

const isMobileMenuOpen = ref(false)

function handleDownloadClick() {
  sendTA('XWEB_CLICK', {
    name: 'android_download_click',
  })
  window.open('https://play.google.com/store/apps/details?id=com.liotek.lannbible', '_blank')
}
</script>
<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: transparent;
  transition: all 0.3s ease;

  &.scrollHeader {
    background: #f9c9db;
  }
}
.nav-link {
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
}
.nav-link.active {
  opacity: 1;
}
</style>
